module.exports = [
  {
    id: 'PL',
    name: 'Poland',
    flag: 'Poland',
    skill: {
      attack: 50,
      midfield: 50,
      defense: 50
    }
  },
  {
    id: 'DE',
    name: 'Germany',
    flag: 'Germany',
    skill: {
      attack: 50,
      midfield: 50,
      defense: 50
    }
  },
  {
    id: 'BR',
    name: 'Brazil',
    flag: 'Brazil',
    skill: {
      attack: 50,
      midfield: 50,
      defense: 50
    }
  },
  {
    id: 'US',
    name: 'United States',
    flag: 'United-States-of-America',
    skill: {
      attack: 50,
      midfield: 50,
      defense: 50
    }
  }
];
